<div class="flex-tiles">
    <div class="flex-tiles__inner">
        <h2 class="flex-tiles__header" [innerHTML]="block.data.text ? block.data.text : block.data.heading"></h2>

        <div class="flex-tiles__tile-wrapper">
            <div class="flex-tiles__item" *ngFor="let block of block.content trackBy: trackByFn;">
                <div class="flex-tiles__content-wrapper">
                    <div class="flex-tiles__content">
                        <h3 class="flex-tiles__content-header" [innerHTML]="block.data.header"></h3>
                        <div class="flex-tiles__content-text" [outerHTML]="block.data.content"></div>
                    </div>
                </div>
                <div class="flex-tiles__image-wrapper">
                    <img class="flex-tiles__image" src="{{block.data.image}}" alt="" />
                </div>
            </div>
        </div>
    </div>
</div>
